'use-strict';

import angular from 'angular';

interface Route extends angular.route.IRoute {
  title?: string,
}

export interface RouteProvider extends angular.route.IRouteProvider {
  when(path: string, route: Route): RouteProvider;
}

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/vehicles/edit/:vehicleId', {
      template: '<vehicle-editor></vehicle-editor>',
      title: 'Fahrzeugeditor',
    })
    .when('/vehicles/new', {
      template: '<vehicle-editor></vehicle-editor>',
      title: 'Fahrzeugeditor',
    })
    .when('/vehicles/new/:vin', {
      template: '<vehicle-editor></vehicle-editor>',
      title: 'Fahrzeugeditor',
    })
    .when('/vehicles/stock', {
      template: '<vehicle-table></vehicle-table>',
      reloadOnSearch: false,
      title: 'Fahrzeuge',
    })
    .when('/vehicles/sold', {
      template: '<vehicle-table></vehicle-table>',
      reloadOnSearch: false,
      title: 'Fahrzeuge',
    })
    .when('/vehicles/dummy', {
      template: '<vehicle-table></vehicle-table>',
      reloadOnSearch: false,
      title: 'Fahrzeuge',
    })
    .when('/vehicles/export', {
      template: '<vehicle-export></vehicle-export>',
      reloadOnSearch: false,
      title: 'Fahrzeugexport',
    })
    .when('/settings/custom-templates', {
      template: '<custom-template-table></custom-template-table>',
      reloadOnSearch: false,
      title: 'Alle Vorlagen',
    })
    .when('/settings/custom-templates/new', {
      template: '<custom-template-form></custom-template-form>',
      title: 'Neue Vorlage anlegen',
    })
    .when('/settings/custom-templates/edit/:templateId', {
      template: '<custom-template-form></custom-template-form>',
      title: 'Vorlage bearbeiten',
    })
    .when('/settings/transactions', {
      template: '<transactions></transactions>',
      title: 'Abrechnung',
    })
    .when('/opportunities/table', {
      template: '<opportunity-table></opportunity-table>',
      title: 'Verkaufschancen',
    })
    .when('/opportunities/new', {
      template: '<opportunity-form></opportunity-form>',
      title: 'Neue Verkaufschance',
    })
    .when('/opportunities/opportunity/:opportunityId', {
      template: '<opportunity></opportunity>',
      title: 'Verkaufschance',
    })
    .when('/analysis', {
      template: '<analysis></analysis>',
      title: 'Kennzahlen Übersicht',
    })
    .when('/analysis/sales', {
      template: '<sales-analysis></sales-analysis>',
      title: 'Verkaufte Fahrzeuge',
    })
    .when('/analysis/handover', {
      template: '<handover-analysis></handover-analysis>',
      title: 'Ausstehende Auslieferungen',
    })
    .when('/support', {
      template: '<support></support>',
      title: 'Hilfeportal',
    });
}
